<div class="row">
    <div class="col" [formGroup]="form">

        <div class="table__viewport" formArrayName="timeregs">
            <table
                class="table table-hover table-striped table-sm table-frame__body"
                cdk-table
                [dataSource]="formTimeregs?.controls"
                [trackBy]="trackById">

                <ng-container cdkColumnDef="dato">
                    <th cdk-header-cell *cdkHeaderCellDef>Dato</th>
                    <td cdk-cell *cdkCellDef="let tr let i = index" [formGroupName]="i" class="td__date">
                        {{ tr.get('dato').value | date:'dd-MM-yyyy' }}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="kunde">
                  <th cdk-header-cell *cdkHeaderCellDef>Kunde</th>
                  <td cdk-cell *cdkCellDef="let tr let i = index" [formGroupName]="i">
                    <span *ngIf="!isEdit(tr.value.id)">
                        {{ tr.get('label')?.value }}
                    </span>
                    <ng-select
                        class="ng-select-sm ng-select__clientcase"
                        *ngIf="isEdit(tr.value.id)"
                        (change)="onClientChange(tr)"
                        [items]="ugerapportKunder"
                        placeholder="Vælg kunde (valgfri)"
                        bindValue="kid"
                        formControlName="kid">
                    </ng-select>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="sag">
                  <th cdk-header-cell *cdkHeaderCellDef>Sag</th>
                  <td cdk-cell *cdkCellDef="let tr let i = index" [formGroupName]="i">
                    <span *ngIf="!isEdit(tr.value.id)">
                        {{ tr.get('sagBeskrivelse')?.value }}
                    </span>
                    <ng-select
                        *ngIf="isEdit(tr.value.id)"
                        class="ng-select-sm ng-select__clientcase"
                        placeholder="Vælg sag (valgfri)"
                        bindValue="sagID"
                        bindLabel="beskrivelse"
                        formControlName="sagID">
                        <ng-option
                            *ngFor="let urs of ugerapportSager | ugerapportSagerFilter:tr.get('kid').value"
                            [value]="urs.sag">
                            {{ urs.beskrivelse }}
                        </ng-option>
                    </ng-select>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="beskrivelse">
                    <th cdk-header-cell *cdkHeaderCellDef>Beskrivelse</th>
                    <td cdk-cell *cdkCellDef="let tr let i = index" [formGroupName]="i">
                        <span *ngIf="!isEdit(tr.value.id)">{{ tr.get('beskrivelse').value }}</span>
                        <input *ngIf="isEdit(tr.value.id)" type="text" class="form-control form-control-sm" formControlName="beskrivelse">
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="timer">
                    <th cdk-header-cell *cdkHeaderCellDef class="text-end">Timer</th>
                    <td class="text-end td__time-money" cdk-cell *cdkCellDef="let tr let i = index" [formGroupName]="i">
                        <span *ngIf="!isEdit(tr.value.id)">{{ tr.get('timer').value | time }}</span>
                        <input
                            *ngIf="isEdit(tr.value.id)"
                            (keydown.enter)="onSave(tr)"
                            type="text"
                            class="form-control form-control-sm text-end"
                            formControlName="timer">
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="funktioner">
                    <th cdk-header-cell *cdkHeaderCellDef class="text-center">
                        <i class="fa fa-pencil d-inline pe-2"></i>
                        <i class="fa fa-floppy-o d-inline pe-2"></i>
                        <i class="fa fa-ban d-inline pe-2"></i>
                        <i class="fa fa-trash d-inline pe-2"></i>
                    </th>
                    <td cdk-cell *cdkCellDef="let tr" class="text-center">
                        <ng-container *ngIf="!tr.value.done">
                            <span
                                *ngIf="!isEdit(tr.value.id) && tr.value.uret === true"
                                class="clickable--link px-1"
                                ngbTooltip="Rediger"
                                (click)="onEdit(tr.value)">
                                <i class="case__icon fa fa-pencil"></i>
                            </span>
                            <span
                                *ngIf="!isEdit(tr.value.id) && tr.value.uret === true"
                                class="clickable--link px-1"
                                ngbTooltip="Slet"
                                (click)="onDelete(tr.value)">
                                <i class="case__icon fa fa-trash text-danger"></i>
                            </span>
                            <span
                                *ngIf="isEdit(tr.value.id)"
                                tabindex="0"
                                class="clickable--link px-1"
                                ngbTooltip="Gem"
                                (keydown.enter)="onSave(tr)"
                                (keydown.space)="onSave(tr)"
                                (click)="onSave(tr)">
                                <i class="case__icon case__icon--show fa fa-floppy-o"></i>
                            </span>
                            <span
                                *ngIf="isEdit(tr.value.id)"
                                tabindex="0"
                                class="clickable--link px-1"
                                ngbTooltip="Annuller"
                                (keydown.enter)="onCancel(tr)"
                                (keydown.space)="onCancel(tr)"
                                (click)="onCancel(tr)">
                                <i class="case__icon case__icon--show fa fa-ban text-danger"></i>
                            </span>
                        </ng-container>
                    </td>
                </ng-container>

                <!-- Footer -->

                <ng-container cdkColumnDef="blank">
                    <th cdk-footer-cell *cdkFooterCellDef></th>
                </ng-container>

                <ng-container cdkColumnDef="total-text">
                    <th cdk-footer-cell *cdkFooterCellDef>Timer i alt</th>
                </ng-container>

                <ng-container cdkColumnDef="total-timer">
                    <th cdk-footer-cell *cdkFooterCellDef class="text-end">{{ totalTimer | time }}</th>
                </ng-container>

                <tr class="table__header--border" cdk-header-row *cdkHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr
                    cdk-row *cdkRowDef="let row; columns: displayColumns"
                    [class.fst-italic]="!row.value.uret"
                    [class.text-secondary]="row.value.done || !row.value.uret"
                ></tr>
                <tr cdk-footer-row *cdkFooterRowDef="['total-text', 'blank', 'blank', 'blank', 'total-timer', 'blank']; sticky: true"></tr>

            </table>
        </div>

    </div>
</div>
